<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>CONTENTS</h1>
<p class="toc"><a class="xref" href="#/chigere0007#intro"><i>Introduction</i>: Diving into the Wreck</a></p>
<p class="tocf"><a class="xref" href="#/chigere0008#ch01">1  Trial of the Archangels</a></p>
<p class="toc"><a class="xref" href="#/chigere0009#ch02">2  Epicurus at the Scaffold</a></p>
<p class="toc"><a class="xref" href="#/chigere0010#ch03">3  Nasty, British, and Short</a></p>
<p class="toc"><a class="xref" href="#/chigere0011#ch04">4  The Monkey in the Panopticon</a></p>
<p class="toc"><a class="xref" href="#/chigere0012#ch05">5  In Which We Wonder Who Is Crazy</a></p>
<p class="toc"><a class="xref" href="#/chigere0013#ch06">6  Epicurus Unchained</a></p>
<p class="tocf"><a class="xref" href="#/chigere0014#aft"><i>Afterword</i>: The Restoration of the Monarchy</a></p>
<p class="tocbmf"><a class="xref" href="#/chigere0015#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chigere0016#biblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/chigere0017#index">Index</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-gere-0006.vue?6dcc854e